import { Skeleton } from '@chakra-ui/react';
import styled, { css } from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';

export const UserThumbnail = styled(UserInitials)`
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 12px;
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;

  & p {
    line-height: 120%;
  }
`;

export const HomeSidePanel = styled.aside`
  padding: 32px;
  border-radius: 0px 8px 0px 0px;
  border-width: 1px 1px 0px 0px;
  border-style: solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.06);
  background-color: ${(props) => props.theme.colors['neutral-0']};
  margin-top: 8px;
  width: 300px;

  & > *:not(:last-child) {
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.colors['neutral-30']};
    margin-bottom: 16px;
  }
`;

export const UserName = styled.p`
  font-weight: 600;
  font-size: 18px;
`;

export const UserTitle = styled.p`
  font-size: 14px;
  margin-top: 4px;
`;

export const LabelWithIconList = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 2px;
  }
`;

const LabelWithIconContainer = styled.div`
  display: flex;
  align-items: center;

  a > & {
    color: ${(props) => props.theme.colors['primary-60']};
  }
`;

const LabelWithIconIcon = styled.div`
  width: 21.5px;
  flex-shrink: 0;

  & > svg {
    width: 15px;
    height: 15px;
    display: block;
  }
`;

const textStyle = css`
  font-size: 14px;
  line-height: 150%;
`;

export const Text = styled.p`
  ${textStyle}
`;

export const LabelWithIconLabelSkeleton = styled(Skeleton)`
  height: 14px;
  margin-top: 4px;
  margin-bottom: 3px;
`;

export const LabelWithIcon = {
  Container: LabelWithIconContainer,
  Icon: LabelWithIconIcon,
  Skeleton: LabelWithIconLabelSkeleton,
};

export const SectionTitle = styled.p`
  font-weight: 600;
  ${textStyle}
`;

export const HireDateSkeletonContainer = styled.div`
  padding-top: 4px;
  padding-bottom: 3px;
`;

export const HireDateSkeleton = styled(Skeleton)`
  height: 14px;
`;

export const ManagerSectionTitle = styled(SectionTitle)`
  margin-bottom: 4px;
`;

export const ManagerContainer = styled.div`
  display: flex;
`;

export const ManagerThumbnailContainer = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 8px;
  width: 24px;
`;

export const ManagerTextBox = styled.div`
  flex-grow: 1;
`;

export const ManagerName = styled.a`
  font-weight: 600;
  ${textStyle}
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const EditProfileButton = styled.a`
  ${textStyle}
  color: ${(props) => props.theme.colors['neutral-80']};

  & > svg {
    font-size: 14px;
    margin-right: 4px;
    position: relative;
    bottom: -1.75px;
  }
`;

export const TeamMembersList = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const TeamMemberThumbnail = styled(UserInitials)`
  display: inline-block;
  text-align: center;
  margin-right: 0;
  line-height: 24px;
  flex-shrink: 0;
`;
